import {RootState} from '../../store/store'

// Selector to get all books
export const selectAllBooks = (state: RootState) => state.books.books

export const selectCurrentBook = (state: RootState) => state.books.currentBook

// Selector to get the loading state
export const selectIsBookLoading = (state: RootState) => state.books.isLoading

// Selector to get any error state
export const selectError = (state: RootState) => state.books.error
